/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const populateChallengeIdsResultSchema = z.object({
  ids: z.array(z.number()),
  remaining: z.number(),
});

export type IPopulateChallengeIdsResult = z.infer<typeof populateChallengeIdsResultSchema>;

export const populateChallengeIdsResponseSchema = createApiResponseSchema(
  populateChallengeIdsResultSchema,
) as z.ZodSchema<IAPI<IPopulateChallengeIdsResult>>;

export type IPopulateChallengeIdsResponse = IAPI<IPopulateChallengeIdsResult>;
